import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Award, Shield, BadgeCheck, Factory, FlaskConical, Settings } from 'lucide-react';

const WhyChooseUs = () => {
  const { t } = useLanguage();

  const features = [
    { key: 'experience', icon: Award },
    { key: 'isoCertified', icon: Shield },
    { key: 'zedCertified', icon: BadgeCheck },
    { key: 'modernInfra', icon: Factory },
    { key: 'qualityControl', icon: FlaskConical },
    { key: 'structuredOps', icon: Settings },
  ];

  return (
    <section className="bg-slate-50 section-spacing" data-testid="why-choose-us-section">
      <div className="container-custom">
        <h2 
          className="text-3xl md:text-5xl font-bold text-[#0047AB] text-center mb-4"
          data-testid="why-choose-us-title"
        >
          {t('whyChooseUs')}
        </h2>
        <div className="section-divider mb-12"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="card-feature group"
              data-testid={`feature-${index}`}
            >
              <div className="feature-icon group-hover:bg-[#0047AB] group-hover:text-white transition-colors duration-300">
                <feature.icon className="w-8 h-8" />
              </div>
              <p className="font-medium text-slate-700">{t(feature.key)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
